export default "__VITE_ASSET__5$CF2Xw3__"